import { Injectable } from '@angular/core';
import { BatchCreateVoyageCommand, BatchNewVoyagesClient, BatchVoyagesClient, GetRefNumbersByOwnerChartererStatusQuery, HistoricVoyagesClient, NewVoyagesClient, VoyagesByContractIdClient, VoyagesByOnwerClient } from 'src/app/web-api-client';
import { ActivateVoyageCommand, CreateVoyageCommand, DownloadVoyageFileQuery, GetVoyageFileDirectoryQuery, UpdateVoyageCommand, VoyagesClient } from 'src/app/web-api-client';

@Injectable({
  providedIn: 'root'
})
export class VoyageService {
  constructor(private service: VoyagesClient, private newVoyage: NewVoyagesClient, private newBatch: BatchNewVoyagesClient, private batch: BatchVoyagesClient, private historic: HistoricVoyagesClient, private contract: VoyagesByContractIdClient, private owner: VoyagesByOnwerClient) { }

  voyages$ = () => this.service.voyages_GetAll();

  voyage$ = (id: number) => this.service.voyages_Get(id);

  create$ = (voyage: CreateVoyageCommand) => this.service.voyages_Create(voyage);

  update$ = (id: number, voyage: UpdateVoyageCommand) => this.service.voyages_Update(id, voyage);

  delete$ = (id: number) => this.service.voyages_Delete(id);

  activate$ = (id: number, command: ActivateVoyageCommand) => this.service.voyages_ActivateVoyage(id, command);

  download$ = (command: DownloadVoyageFileQuery) => this.service.voyages_DownloadVoyageFile(command);

  movesByRefNumber$ = (refNumber: number) => this.service.voyages_GetMoveNumbersByOwner(refNumber);

  refNumbesByOwnerChartererStatus$ = (query: GetRefNumbersByOwnerChartererStatusQuery) => this.service.voyages_GetRefNumbersByOwnerChartererStatus(query);

  directory$ = (command: GetVoyageFileDirectoryQuery) => this.service.voyages_GetVoyageFileDirectory(command);

  voyagesByStatus$ = (status: string) => this.service.voyages_GetVoyagesByStatus(status);

  newBatch$ = (id: number) => this.newBatch.batchNewVoyages_Get(id);

  batch$ = (id: number) => this.batch.batchVoyages_Get(id);

  newVoyage$ = (id: number) => this.newVoyage.newVoyages_Get(id);

  createBatch$ = (command: BatchCreateVoyageCommand) => this.batch.batchVoyages_Create(command);

  historic$ = () => this.historic.historicVoyages_Get();

  voyageByContractId$ = (id: number) => this.contract.voyagesByContractId_Get(id);

  voyagesByOwner$ = (name: string) => this.owner.voyagesByOnwer_Get(name);
}
